import React from 'react';
import ArcaChip from './ArcaChip';

const OBS_COPY = {
  observado:
    'El CAE existe en ARCA pero hay diferencias con los datos extraídos. Revisá el comprobante antes de aceptarlo.',
  observed:
    'El CAE existe en ARCA pero hay diferencias con los datos extraídos. Revisá el comprobante antes de aceptarlo.',
  rechazado:
    'El comprobante no figura en los registros de ARCA. Puede ser apócrifo o tener un error de carga.',
  rejected:
    'El comprobante no figura en los registros de ARCA. Puede ser apócrifo o tener un error de carga.',
  error:
    'No se pudo validar contra ARCA por un error técnico. La extracción sigue siendo válida y se puede reintentar.',
  skipped_missing_fields:
    'Faltan datos fiscales mínimos para constatar el comprobante en ARCA.',
};

export default function ArcaBadge({
  arca,
  fiscal,
  fiscalEnrichment,
  loading = false,
  onConstatar,
  onShowDetails,
}) {
  const state = arca?.state || arca?.status || 'sin_constatar';
  const obsMsg = OBS_COPY[state];

  return (
    <div className="dv-arca-box">
      <ArcaChip arca={arca} loading={loading} />
      <span className="dv-arca-meta">
        {fiscal?.cae ? (
          <>
            CAE <b className="mono">{fiscal.cae}</b>
            {arca?.checked_at && (
              <> · constatado {new Date(arca.checked_at).toLocaleString('es-AR')}</>
            )}
          </>
        ) : (
          'Sin datos de constatación'
        )}
      </span>
      {onConstatar && (
        <button
          type="button"
          className="dv-btn"
          disabled={loading}
          onClick={onConstatar}
        >
          ↻ {state === 'sin_constatar' ? 'Constatar ARCA' : 'Re-constatar ARCA'}
        </button>
      )}
      {obsMsg && <div className={`dv-arca-obs dv-arca-obs--${state}`}>{obsMsg}</div>}
      {(arca?.observaciones || arca?.observations || []).map((msg, i) => (
        <div key={i} className="dv-arca-obs dv-arca-obs--observado">
          {msg}
        </div>
      ))}
      {(arca?.errors || []).map((msg, i) => (
        <div key={`err-${i}`} className="dv-arca-obs dv-arca-obs--rechazado">
          {msg}
        </div>
      ))}
      {onShowDetails && (() => {
        const arcaStatus = arca?.state || arca?.status;
        return arcaStatus && !['sin_constatar', 'pending', 'not_enabled'].includes(arcaStatus);
      })() && (
        <button
          type="button"
          className="dv-btn dv-btn--ghost"
          onClick={onShowDetails}
        >
          Ver detalle de validación
        </button>
      )}
      {(fiscalEnrichment?.warnings || []).includes('cuit_emisor_low_confidence_no_qr') && (
        <div className="dv-arca-obs dv-arca-obs--observado">
          Revisá el CUIT emisor antes de constatar — la extracción fue incierta.
        </div>
      )}
    </div>
  );
}
